import './tuidea.css';

const Idea = () => {
  return (
    <div className="iframe-container">
      <h1>Tu idea</h1>
      <iframe
        title="idea"
        src="https://forms.office.com/Pages/ResponsePage.aspx?id=PTPrKun-zE6lChFwi8SscgaC4X80uQxGhplUhRMi3XZUMVdFM0hDRVo3TEhVR08yNTJCVk1LWlpaOC4u&embed=true" 
        frameborder= "0"
        marginWidth= "0"
        marginHeight= "0">
      </iframe>
    </div>
  );
}
 
export default Idea;